export default "__VITE_ASSET__DpPUkXc5__"